import { configureStore } from "@reduxjs/toolkit";
import { baseApi } from "@/api/base";

const rootReducer = {
  [baseApi.reducerPath]: baseApi.reducer,
};

const middleware = [baseApi.middleware];
const preloadedState = {};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middleware),
  devTools: process.env.NODE_ENV !== "production",
  preloadedState,
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch;
